import React from "react";
import {ListWrapper} from "../ui/Catalog";
import {connect} from "react-redux";
import {channel} from '../repository/index'
import {withRouter} from "react-router-dom";
import DetailsProduct from "../ui/Catalog/DetailsProducts";


const ChannelController = (props) => {
    return <div>
        {!props.match.params.id
            ? <ListWrapper {...props} url={'channel'}/>
            : <DetailsProduct products={channel} id={props.match.params.id}/>}
    </div>
};

const mapState = (state) => {
    return {
        data: state.catalogPage.channel
    }
};

export default withRouter(connect(mapState, null)(ChannelController));
